import self from '@/common/utils/global-config';
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';

export default {
  data() {
    return {
      serial: self.$sn.utils.getHospitalLocalStorage('LoginCodeSerial') || 60
    };
  },
  created: function() {
    if (this.serial < 60) this.login_mixin_formatSerial();
  },
  methods: {
    // 格式化动态码倒计时
    login_mixin_formatSerial() {
      if (this.serial === 0) {
        this.serial = 60;
        this.$sn.utils.setHospitalLocalStorage('LoginCodeSerial', this.serial, false);
      }
      else {
        this.serial--;
        this.$sn.utils.setHospitalLocalStorage('LoginCodeSerial', this.serial, false);
        setTimeout(() => {
          this.login_mixin_formatSerial();
        }, 1 * 1000);
      }
    },
    // 获取动态码
    login_mixin_sendCode(phone, codeType) {
      if (this.serial < 60) return false;
      if (!this.$sn.validate.phone(phone)) {
        this.$sn.assembly.toast({
          caption: Messages.C013
        });
        return false;
      }
      const params = {
        url: Swagger.sendCode,
        method: 'POST',
        data: JSON.stringify({
          codeType: codeType,
          hosId: this.$sn.utils.getHospitalId(),
          mobile: phone,
          platformType: this.$sn.utils.getPlatformType(),
          projectType: '',
          realIp: ''
        })
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result) {
          if (result.code === 0) {
            this.login_mixin_formatSerial();
            this.$sn.assembly.toast({
              caption: this.$sn.format.caption(Messages.PATIENT023, [this.$sn.encrypted.phone(phone)])
            });
          }
          else {
            this.$sn.assembly.toast({
              caption: result.msg
            });
          }
        }
        else {
          this.$sn.assembly.toast({
            caption: Messages.C001
          });
        }
      });
    },
    login_mixin_verifyRegister(phone) {
      return new Promise(resolve => {
        const res = {
          code: 1,
          data: false,
          msg: ''
        };
        const params = {
          url: Swagger.verifyRegisterEncryption,
          query: {
            mobile: this.$sn.utils.variableEncryption(phone)
          }
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            res.code = 0;
            res.data = result.code !== 0;
          }
          else {
            res.msg = Messages.C001;
          }
          resolve(res);
        });
      });
    },
    login_mixin_suffixLogin(result) {
      this.$sn.vuex.set('vuex_login_user.' + this.$sn.utils.getHospitalId(), {
        ...result,
        isLogin: true
      });
      this.$sn.assembly.loading(true);
      Initial.suffixLogin().then(() => {
        this.$sn.assembly.loading(false);
        let leave = {
          path: '/'
        };
        if (!this.$sn.validate.empty(this.$sn.utils.getHospitalSessionStorage('CurrentTrajectory'))) {
          leave = this.$sn.utils.getHospitalSessionStorage('CurrentTrajectory');
        }
        this.login_mixin_navigateUrl(leave.path, '', leave.query, 'replace');
      });
    },
    login_mixin_navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === '') {
      }
      else if (url.substring(0, 4) === 'http' || url.substring(0, 7) === '/static' || url.substring(0, 2) === '//') {
        window.location.href = url;
      }
      else {
        this.$router[type]({
          path: url,
          query: params || {}
        });
      }
    }
  }
};
